import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from 'swiper';
Swiper.use([Navigation, Autoplay, Pagination, EffectFade]);
/**============================================================
*   [お知らせ]
*   description : お知らせスライダーの処理を記述
============================================================*/

var homeUrl = location.pathname;
if (homeUrl == '/') {
  window.addEventListener('load', function () {

    function initSwiper() {
      var mySwiper = new Swiper('.swiper-container', { // eslint-disable-line
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 3000,
        },
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          formatFractionCurrent: function (number) {
            return '0' + number;
          },
          formatFractionTotal: function (number) {
            return '0' + number;
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    }
    initSwiper();
  });

  window.addEventListener('load', function () {
    var mql = window.matchMedia('(min-width: 641px)');
    var mySwiper = null;

    function initSwiper() {
      if (mql.matches) {
        mySwiper = new Swiper('.swiper-news', {
          loop: false,
          slidesPerView: 2,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            941: {
              slidesPerView: 3
            }
          },
          watchOverflow: true
        });
      } else {
        if (mySwiper) {
          mySwiper.destroy();
          mySwiper = undefined;
        }
      }
    }

    mql.addEventListener('change', initSwiper);
    initSwiper();
  });
}
